// Carga de Google Analytics (gtag) SOLO con consentimiento de cookies.
// El ID de medición (G-XXXX) se gestiona desde el panel y se sirve en /api/settings/public.
const CONSENT_KEY = "topacio_cookie_consent";
let loaded = false;

export function hasAnalyticsConsent() {
  try {
    const c = JSON.parse(localStorage.getItem(CONSENT_KEY) || "null");
    return !!c && c.value === "accepted";
  } catch {
    return false;
  }
}

export function loadGA(id) {
  if (!id || loaded || typeof window === "undefined") return;
  if (!/^(G-[A-Z0-9]{4,}|UA-\d{4,}-\d+)$/i.test(id)) return;
  if (!hasAnalyticsConsent()) return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id, { anonymize_ip: true });
}
